import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Gallery from './components/Gallery';
import Pricing from './components/Pricing';
import WhyFitFrame from './components/WhyFitFrame';
import BottomCTA from './components/BottomCTA';
import BookingForm from './components/BookingFormNew';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminBookings from './components/AdminBookings';
import { Toaster } from './components/ui/sonner';
import './App.css';

function HomePage() {
  return (
    <>
      <Navigation />
      <Hero />
      <Services />
      <Process />
      <Gallery />
      <Pricing />
      <WhyFitFrame />
      <BottomCTA />
      <BookingForm />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
